import { Component, ElementRef, HostListener, ViewChild, inject, signal } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LocaleService, SUPPORTED_LOCALES } from '../../core/locale.service';
import { IconComponent } from '../icon/icon.component';

/**
 * The language menu for the pages shown before sign-in (issue #420): the same globe button and EN / AR list as the app header's. Nobody is
 * signed in there, so a choice is only applied and remembered in this browser (LocaleService.apply keeps it); once the person signs in, their
 * account's own language applies, like after any sign-in. The header's menu also saves the choice on the account, which has no account to
 * go to here.
 */
@Component({
  selector: 'app-language-switch',
  standalone: true,
  imports: [TranslatePipe, IconComponent],
  templateUrl: './language-switch.component.html',
  styleUrl: './language-switch.component.scss',
})
export class LanguageSwitchComponent {
  private readonly locale = inject(LocaleService);
  private readonly translate = inject(TranslateService);

  readonly locales = SUPPORTED_LOCALES;
  readonly isOpen = signal(false);

  @ViewChild('menu') private menuRef?: ElementRef<HTMLElement>;

  get currentLocale(): string {
    return this.translate.currentLang() || document.documentElement.lang || 'ar';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isOpen() && !this.menuRef?.nativeElement.contains(event.target as Node)) this.isOpen.set(false);
  }

  toggle(): void {
    this.isOpen.set(!this.isOpen());
  }

  select(locale: string): void {
    this.isOpen.set(false);
    this.locale.apply(locale);
  }
}
